import { render, staticRenderFns } from "./ListInvitation.vue?vue&type=template&id=4ee71fca&"
import script from "./ListInvitation.vue?vue&type=script&lang=js&"
export * from "./ListInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports